import { ReportFilters } from '../types/Report';
import { ComparisonFilters } from '../services/comparisonDashboardService';
import { appendReportFiltersToSearchParams } from './reportFilters';

export type ExecutiveDashboardView = 'breakdown' | 'movers';

/** Map executive report filters to comparison dashboard API filters (same date range & dimensions). */
export function reportFiltersToComparisonFilters(filters: ReportFilters): ComparisonFilters {
  const c: ComparisonFilters = {};
  if (filters.startDate) c.start_date = filters.startDate;
  if (filters.endDate) c.end_date = filters.endDate;
  if (filters.brandIds?.length) c.brands = filters.brandIds;
  if (filters.categoryIds?.length) c.categories = filters.categoryIds;
  if (filters.customerIds?.length) c.customers = filters.customerIds;
  if (filters.territoryIds?.length) c.territories = filters.territoryIds;
  if (filters.salesPersonIds?.length) c.sales_reps = filters.salesPersonIds;
  if (filters.productIds?.length) c.product_ids = filters.productIds;
  return c;
}

export function appendExecutiveDashboardSearchParams(
  filters: ReportFilters,
  dashboardView: ExecutiveDashboardView,
  params: URLSearchParams = new URLSearchParams()
): URLSearchParams {
  const p = appendReportFiltersToSearchParams(filters, params);
  if (dashboardView === 'breakdown') {
    p.set('dashboardView', 'breakdown');
  } else {
    p.delete('dashboardView');
  }
  return p;
}

export function parseExecutiveDashboardView(raw: string | null): ExecutiveDashboardView {
  return raw === 'breakdown' || raw === 'movers' ? raw : 'movers';
}
